import http from '../../api/http'
import base from '../../api/base.js'
import {rulesMenu} from '@/utils/common'
import {anyRoutes,resetRouter,asyncRoutes,constantRoutes} from '@/router'
import router from '@/router'
import cloneDeep from 'lodash/cloneDeep'
export default {
	namespaced: true,
	state: {
		dymenuList: [],
		asyncMenu:[],
		logoInfo:{
			title:'',
			logo:'',
			logotitle:''
		}
	},
	mutations: {
		//设置用户信息
		setMenu(state, payload) {
			state.dymenuList = payload;
		},	
		setasyncMenu(state, payload) {
			state.asyncMenu = payload;
		},	
		setlogoInfo(state, payload) {
			state.logoInfo = payload;
		},						
		//清空
		clearMenu(state) {
			state.dymenuList = []
		},
		clearasyncMenu(state) {
			state.asyncMenu = []
		},
		clearlogoInfo(state) {
			state.logoInfo= {
				title:'',
				logo:'',
				logotitle:''
			}
		},
	},
	actions: {
		getMenu({ commit, state }) {						
			return new Promise((resolve, reject) => {
			    http.get('index/getSystemInit').then(res => {
			    	let rules=res.data.menuInfo;
					commit('setlogoInfo',res.data.siteInfo);
			    	//state.menuModule.dymenuList=rules;
					commit('setMenu',rules);
			    	/*let menus=rulesMenu(cloneDeep(menu),rules);
			    	menus.forEach(ele=>{
			    		constantRoutes[0].children.push(ele);
			    	})	*/
					let menus=[];
					rules.forEach(ele=>{
						ele.child.forEach(childitem=>{
							let item={
								path:childitem.href,
								component: () => import(`@/views${childitem.href}`),
								name:childitem.href,
								meta:{
									title:childitem.title
								}	
							}
							menus.push(item);							
						})					
					})			
					menus.forEach(ele=>{
						constantRoutes[0].children.push(ele);
					})			
					commit('setasyncMenu',constantRoutes.concat(anyRoutes));
					router.addRoutes(constantRoutes.concat(anyRoutes));
					router.options.routes = constantRoutes.concat(anyRoutes);
					resolve(rules)
			    }).catch(error => {
			    	reject(error);
			    });					
			})	
		}		 
	},
	getters: {

	},
}
